import { useMutation } from '@tanstack/react-query';

import { getCompanyPosition } from '../../api/leadSearchApi';

import { leadSearchMutationKeys } from './keys';

export function useCompanyPosition() {
	return useMutation({
		mutationKey: leadSearchMutationKeys.position,
		mutationFn: getCompanyPosition,
		// A stale hit (company excluded meanwhile) is handled inline in the overlay.
		meta: { suppressGlobalError: true },
	});
}
